import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatError(detail) {
    if (!detail) return 'Something went wrong. Please try again.';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
    return String(detail);
}

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        try {
            const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    };

    const login = async (username, password) => {
        try {
            const { data } = await axios.post(`${API}/auth/login`, { username, password }, { withCredentials: true });
            setUser(data);
            return { success: true, data };
        } catch (e) {
            return { success: false, error: formatError(e.response?.data?.detail) || e.message };
        }
    };

    const logout = async () => {
        try {
            await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
        } catch {}
        setUser(false);
    };

    const hasRole = (...roles) => {
        if (!user) return false;
        if (user.role === 'admin') return true;
        return roles.includes(user.role);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, setUser, hasRole, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
export { API };
